// extracted by mini-css-extract-plugin
module.exports = {"disc":"List_disc__51PBx","circle":"List_circle___G_Bz","square":"List_square__eqhQf","decimal":"List_decimal__q6ntX","georgian":"List_georgian__nlp_z"};